const TIMEOUT_DURATION = typeof window.TEST_TIMEOUT_DURATION === 'number' ? window.TEST_TIMEOUT_DURATION : 900;
const WARNING_THRESHOLD = typeof window.TEST_WARNING_THRESHOLD === 'number' ? window.TEST_WARNING_THRESHOLD : 60;
const USER_ACTIVITY_EVENTS = ['keydown', 'click'];

export const getDefaultState = () => ({
  remainingSeconds: TIMEOUT_DURATION,
  countdownTimer: null,
  countdownTarget: null,
  cleanupListeners: null,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  SET_REMAINING_SECONDS: 'SET_REMAINING_SECONDS',
  SET_COUNTDOWN_TIMER: 'SET_COUNTDOWN_TIMER',
  SET_COUNTDOWN_TARGET: 'SET_COUNTDOWN_TARGET',
  SET_CLEANUP_LISTENERS: 'SET_CLEANUP_LISTENERS',
  CLEAR_COUNTDOWN_TIMER: 'CLEAR_COUNTDOWN_TIMER',
};

export const mutations = {
  [types.RESET](state) {
    if (state.countdownTimer) clearInterval(state.countdownTimer);
    if (state.cleanupListeners) state.cleanupListeners();

    Object.assign(state, getDefaultState());
  },
  [types.SET_REMAINING_SECONDS](state, seconds) {
    state.remainingSeconds = seconds;
  },
  [types.SET_COUNTDOWN_TIMER](state, timer) {
    state.countdownTimer = timer;
  },
  [types.SET_COUNTDOWN_TARGET](state, target) {
    state.countdownTarget = target;
  },
  [types.CLEAR_COUNTDOWN_TIMER](state) {
    if (state.countdownTimer) clearInterval(state.countdownTimer);
    state.countdownTimer = null;
  },
  [types.SET_CLEANUP_LISTENERS](state, cleanupFunction) {
    state.cleanupListeners = cleanupFunction;
  },
};

export const actions = {
  initializeTimer({ dispatch, commit }) {
    const startActivity = () => {
      dispatch('timer/startCountdown', TIMEOUT_DURATION, { root: true });
    };

    USER_ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, startActivity);
    });

    const cleanupFunction = () => {
      USER_ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, startActivity);
      });
    };

    commit(types.SET_CLEANUP_LISTENERS, cleanupFunction);

    startActivity();
  },

  startCountdown({ commit, dispatch }, seconds = TIMEOUT_DURATION) {
    commit(types.CLEAR_COUNTDOWN_TIMER);

    commit(types.SET_REMAINING_SECONDS, seconds);
    const target = Date.now() + seconds * 1000;
    commit(types.SET_COUNTDOWN_TARGET, target);

    const timer = setInterval(() => {
      const diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
      commit(types.SET_REMAINING_SECONDS, diff);
      if (diff <= 0) {
        commit(types.CLEAR_COUNTDOWN_TIMER);
        dispatch('timer/logoutUser', null, { root: true });
      }
    }, 250);
    commit(types.SET_COUNTDOWN_TIMER, timer);
  },

  stopListener({ commit }) {
    if (state.cleanupListeners) {
      state.cleanupListeners();
      commit(types.SET_CLEANUP_LISTENERS, null);
    }
  },

  cleanupTimer({ commit, dispatch }) {
    dispatch('timer/stopListener', null, { root: true });
    commit(types.CLEAR_COUNTDOWN_TIMER);
  },

  logoutUser({ dispatch }) {
    dispatch('system/logoutEvent', null, { root: true });
  },
};

export const getters = {
  remainingSeconds: (state) => state.remainingSeconds,
  warningThreshold: () => WARNING_THRESHOLD,
};
